import React, { useEffect, useRef, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Spinner, Form, Button, Container, Row, Col } from 'react-bootstrap'
import { Typeahead } from 'react-bootstrap-typeahead'
import 'react-bootstrap-typeahead/css/Typeahead.css';

import Pagination from './components/pagination'
import Publication from './components/Publication';
import {
  getPublications,
  setSinglePublication,
  getMetadata,
  changePage,
  setSelectedTherapeuticAreas,
  setSelectedYears,
  setLimit
} from './reducers/managePublications'
import logo from '../static/logos/GenesisResearch_FullLogoRevised.jpg'
import { useParams } from "react-router-dom"
import { publicationsHttp } from "../common/http"
import './style.css'


export default function PublicationsContainer() {
  // REACT ROUTER DOM
  const { publicationId } = useParams()
  // REDUX
  const dispatch = useDispatch()
  const {
    publications,
    metadata,
    publicationCount,
    currentPage,
    limit,
    loading,
    selectedTherapeuticAreas,
    selectedYears,
  } = useSelector(state => state.managePublications)

  // STATE
  const [searchTerm, setSearchTerm] = useState("")

  const ref1 = useRef()
  const ref3 = useRef()

  useEffect(() => {
    let nav = document.querySelector('#nav')
    if (nav) {
        nav.style.display = 'none'
        window.scroll(0, 0)
    }

    dispatch(getMetadata())

    if (publicationId) {
      publicationsHttp.get(`/${publicationId}`)
      .then(response => {
        setSearchTerm(response.data.citation)
        dispatch(setSinglePublication(response.data))
      })
      .catch(error => {
        dispatch(getPublications())
      })
    } else {
      dispatch(getPublications())
    }
  }, [dispatch, publicationId])

  const handlePageChange = (selectedPage) => {
    dispatch(changePage(selectedPage))
    const filters = {
      therapeutic_areas: selectedTherapeuticAreas,
      years: selectedYears,
      search_term: searchTerm,
    }
    dispatch(getPublications(selectedPage, filters))
  }

  const handleTherapeuticAreasFilter = (selection) => {
    dispatch(setSelectedTherapeuticAreas(selection))
    dispatch(changePage(1))

    const filters = {
      therapeutic_areas: selection,
      years: selectedYears,
      search_term: searchTerm,
    }
    dispatch(getPublications(1, filters))
  }

  const handleYearsFilter = (selection) => {
    dispatch(setSelectedYears(selection))
    dispatch(changePage(1))

    let filters = {
      therapeutic_areas: selectedTherapeuticAreas,
      years: selection,
      search_term: searchTerm,
    }
    dispatch(getPublications(1, filters))
  }

  const handleChangeSearch = (e) => {
    const currentSearchTerm = searchTerm
    const newSearchTerm = e.target.value

    setSearchTerm(newSearchTerm)
    if (newSearchTerm === "" && currentSearchTerm.length >= 1) {
      handleResetSearch()
    }
  }

  const handleResetSearch = () => {
    dispatch(changePage(1))
    setSearchTerm("")

    const filters = {
      therapeutic_areas: selectedTherapeuticAreas,
      years: selectedYears,
      search_term: "",
    }
    dispatch(getPublications(1, filters))
  }

  const handleSearchSubmit = (e) => {
    e.preventDefault()
    dispatch(changePage(1))

    const filters = {
      therapeutic_areas: selectedTherapeuticAreas,
      years: selectedYears,
      search_term: searchTerm,
    }
    dispatch(getPublications(1, filters))
  }

  const handleChangeLimit = (e) => {
    dispatch(setLimit(e.target.value))

    const filters = {
      therapeutic_areas: selectedTherapeuticAreas,
      years: selectedYears,
      search_term: searchTerm,
    }
    dispatch(getPublications(1, filters))
  }

  const mapPublications = (pubs) => {
    return pubs.map((pub, index) => {
      return <Publication publication={pub} key={index} />
    })
  }


  return (
    <div className="publications-page" style={{fontFamily: "'Open Sans', sans-serif"}}>
      {/*<HamburgerNav />*/}
      <a id="back-btn" href="https://genesisrg.com"><img id="logo" src={logo} alt="Genesis Research" style={{cursor: "pointer"}} /></a>
      <a id="back-btn" href="https://genesisrg.com"><i className="fa fa-arrow-left"></i>To Genesis Research Group homepage</a>
      <br />
      <br />

      <div className="publications-header">
        <h1 className='page-header'>SELECTED PUBLICATIONS</h1>
      </div>
      <div id="publications-filter">
        <Form onSubmit={handleSearchSubmit}>
          <Container>
            <Row style={{alignItems: "flex-end"}}>
              <Col lg={10} md={10} sm={12} xs={12}>
                <p>Search</p>
                <Form.Control
                  className="pub-filters search"
                  type="search"
                  placeholder="Search publications by Type, Citation, Author, Indication, Data Source, Method Analysis, Study Design"
                  value={searchTerm}
                  disabled={!!loading}
                  onChange={handleChangeSearch}
                />
              </Col>
              <Col lg={2} md={2} sm={12} xs={12}>
                <Button
                  className="btn search"
                  type="submit"
                  onClick={handleSearchSubmit}
                >
                  Search
                </Button>
              </Col>
            </Row>
          </Container>
        </Form>
        <div className="pub-filters">
          <Container>
            <Row>
              <Col lg={5} md={5} sm={12} xs={12}>
                <div className="pub-filters filter">
                  <p>Therapeutic Area(s)</p>
                  <Typeahead
                    id="therapeutic-areas-filter"
                    multiple
                    disabled={!!loading}
                    placeholder="Select Therapeutic Area(s)"
                    clearButton={true}
                    ref={ref1}
                    onChange={(selection) => {
                      ref1.current.blur()
                      ref1.current.focus()
                      handleTherapeuticAreasFilter(selection)
                    }}
                    options={metadata.therapeutic_areas ? metadata.therapeutic_areas : ["Loading"]}
                  />
                </div>
              </Col>
              <Col lg={5} md={5} sm={12} xs={12}>
                <div className="pub-filters filter">
                  <p>Year Published</p>
                  <Typeahead
                    id="years-filter"
                    multiple
                    disabled={!!loading}
                    placeholder="Select Year(s)"
                    clearButton={true}
                    ref={ref3}
                    onChange={(selection) => {
                      ref3.current.blur()
                      ref3.current.focus()
                      handleYearsFilter(selection)
                    }}
                    options={metadata.years ? metadata.years : ["Loading"]}
                  />
                </div>
              </Col>
              <Col lg={2} md={2} sm={12} xs={12}>
                <div className="pub-filters filter">
                  <p>Results Per Page</p>
                  <Form>
                    <Form.Control as="select" onChange={handleChangeLimit}>
                      <option>10</option>
                      <option>20</option>
                      <option>30</option>
                      <option>40</option>
                    </Form.Control>
                  </Form>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
      <div className="pubs-contact-container">
        <a className="pubs-button-link" href="mailto:solutions@genesisrg.com">Contact an Author</a>
      </div>
      <div className="pub-pagination">
        <Pagination
          totalPages={Math.ceil(publicationCount / limit)}
          currentPage={currentPage}
          pageNeighbors={1}
          handlePageChange={handlePageChange}
        />
      </div>
      <ul>
        {loading ?
          <div style={{textAlign: 'center'}}>
            <Spinner animation="border" role="status" variant="light">
              <span className="sr-only">Loading...</span>
            </Spinner>
          </div>
          :
          <div id="publications-container">
            {publications && publications.length ?
              mapPublications(publications)
              :
              <div className="empty-pubs-list">
                <h3>No Publications Found</h3>
              </div>
            }
          </div>
        }
      </ul>
      {loading ?
        null
        :
        <>
          <div className="pubs-contact-container">
            <a className="pubs-button-link" href="mailto:solutions@genesisrg.com">Contact an Author</a>
          </div>
          <div className="pub-pagination">
            <Pagination
              totalPages={Math.ceil(publicationCount / limit)}
              currentPage={currentPage}
              pageNeighbors={1}
              handlePageChange={handlePageChange}
            />
          </div>
        </>
      }
      <br />
      <br />
      <a id="back-btn" href="https://genesisrg.com"><i className="fa fa-arrow-left"></i>To Genesis Research Group homepage</a>
    </div>
  )
}